import * as angular from "angular";
import {IController} from "angular";

export class AccountListCtrl implements IController {

  ids: any;
  showLink: any;
}

angular
  .module('bringoz.admin.accounts')
  .component('accountList', {
    bindings: {
      ids: '<',
      showLink: '@?'
    },
    template: require('./account-list.html').default,
    controller: AccountListCtrl
  });
